import { Route, Switch, useLocation } from "react-router";
import { ThemeProvider } from "styled-components";
import { lightTheme } from "./components/Themes";
import GlobalStyle from "./globalStyles";

import Main from "./components/Main";
import AboutPage from "./components/AboutPage";
import BlogPage from "./components/BlogPage";
import WorkPage from "./components/WorkPage";
import MySkillsPage from "./components/MySkillsPage";
import ExperiencePage from "./components/ExperiencePage";
import VanakkamDsaPage from "./components/VanakkamDsaPage";
import YoutubePage from "./components/YoutubePage";
import SpeakingPage from "./components/SpeakingPage";
import OpenSourcePage from "./components/OpenSourcePage";
import ContactPage from "./components/ContactPage";
import NotFoundPage from "./components/NotFoundPage";
import { AnimatePresence } from "framer-motion";

function App() {
  const location = useLocation();

  return (
    <>
      <GlobalStyle />
      <ThemeProvider theme={lightTheme}>
        <AnimatePresence exitBeforeEnter>
          <Switch location={location} key={location.pathname}>
            <Route exact path="/" component={Main} />
            <Route exact path="/about" component={AboutPage} />
            <Route exact path="/blog" component={BlogPage} />
            <Route exact path="/work" component={WorkPage} />
            <Route exact path="/projects" component={WorkPage} />
            <Route exact path="/skills" component={MySkillsPage} />
            <Route exact path="/experience" component={ExperiencePage} />
            <Route exact path="/vanakkam-dsa" component={VanakkamDsaPage} />
            <Route exact path="/youtube" component={YoutubePage} />
            <Route exact path="/speaking" component={SpeakingPage} />
            <Route exact path="/open-source" component={OpenSourcePage} />
            <Route exact path="/contact" component={ContactPage} />
            <Route component={NotFoundPage} />
          </Switch>
        </AnimatePresence>
      </ThemeProvider>
    </>
  );
}

export default App;
